<button mat-stroked-button 
    *ngIf="cps.isEnabled(TMCClientParameters.FEATURES_LINK_TRANSPORTS, false) && asButton" 
    (click)="linkTransports()" 
    [disabled]="disabled && asButton"
    title="{{'attach / detach' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.link', translationService.language]}}">
    <sc-icon iconClass="fa-link"></sc-icon>
</button>
<button mat-icon-button 
    *ngIf="cps.isEnabled(TMCClientParameters.FEATURES_LINK_TRANSPORTS, false) && !asButton" 
    (click)="linkTransports()" 
    [disabled]="disabled && !asButton"
    title="{{'attach / detach' | translate:['tmc-yard.widgets.sac-client.station-transport-details.action.link', translationService.language]}}">
    <sc-icon iconClass="fa-link"></sc-icon>
</button>